module.exports = __webpack_public_path__ + "img/cancel-btn.489287f2.svg";